module.exports = __webpack_public_path__ + "img/g_mro_3.e49992cc.png";